module.exports = __webpack_public_path__ + "static/images/styles/images/dots-pattern-y.4fe3cb77.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/dots-pattern-y.png
// module id = 3623
// module chunks = 11